/**
 * KAN-940: текст поля ввода сообщения с черновиком по ключу (обычно
 * client:<id>). С ключом текст восстанавливается при открытии и при смене
 * ключа, каждая правка пишется в черновик (пустая убирает его). Без ключа
 * обычный useState, хранилище не трогается.
 */
import { useCallback, useState } from 'react';
import { readComposerDraft, writeComposerDraft } from '@/lib/composerDraft';

interface DraftState {
  key: string | undefined;
  text: string;
}

export function useComposerDraft(draftKey?: string): [string, (text: string) => void] {
  const [state, setState] = useState<DraftState>(() => ({ key: draftKey, text: readComposerDraft(draftKey) }));

  // Сменился клиент: показать его черновик (подстройка состояния во время рендера).
  let current = state;
  if (state.key !== draftKey) {
    current = { key: draftKey, text: readComposerDraft(draftKey) };
    setState(current);
  }

  const setText = useCallback(
    (text: string) => {
      setState({ key: draftKey, text });
      writeComposerDraft(draftKey, text);
    },
    [draftKey]
  );

  return [current.text, setText];
}
